import { AsyncPipe } from '@angular/common';
import {
  ChangeDetectionStrategy,
  Component,
  OnInit,
  inject,
} from '@angular/core';
import { MatButtonModule } from '@angular/material/button';
import { MatDialogModule } from '@angular/material/dialog';
import { MatIconModule } from '@angular/material/icon';
import { MatProgressSpinnerModule } from '@angular/material/progress-spinner';
import { TranslocoModule } from '@ngneat/transloco';
import { InfiniteScrollDirective } from 'ngx-infinite-scroll';
import { take } from 'rxjs';
import { NotificationItemComponent } from 'src/app/entities/notifications/components/notification-item/notification-item.component';
import { NotificationsService } from 'src/app/entities/notifications/state/notifications.service';

import { NotificationsRepository } from '../../state/notification.repository';

@Component({
  standalone: true,
  selector: 'sandoz-notifications-dialog',
  templateUrl: './notifications-dialog.component.html',
  styleUrls: ['./notifications-dialog.component.scss'],
  changeDetection: ChangeDetectionStrategy.OnPush,
  imports: [
    AsyncPipe,
    TranslocoModule,

    NotificationItemComponent,
    InfiniteScrollDirective,

    MatButtonModule,
    MatIconModule,
    MatDialogModule,
    MatProgressSpinnerModule,
  ],
})
export class NotificationsDialogComponent implements OnInit {
  protected readonly notificationService = inject(NotificationsService);
  protected readonly notificationRepo = inject(NotificationsRepository);

  ngOnInit(): void {
    // Reset the store state first
    this.notificationService.destroyNotificationsSubscription();
    this.notificationRepo.setPage(1);

    // if the dialog was not opened yet, and we have notifications already in the store, mark them as read when dialog is opened
    if (
      !this.notificationRepo.getStoreProp('wasDialogOpened') &&
      this.notificationRepo.getIds()?.length
    ) {
      this.notificationService
        .markNotificationsAsRead(this.notificationRepo.getIds()!)
        .pipe(take(1))
        .subscribe();
    }

    // if dialog was opened before and after reopening, while in unread mode, there are not any
    // notifications in the store, but there is a next page then we need to fetch the
    // first page again to refetch the unread notifications
    const state = this.notificationRepo.getState();
    if (
      state.wasDialogOpened &&
      !this.notificationRepo.count$ &&
      state.nextPage &&
      state.mode === 'unread'
    ) {
      this.notificationService.initNotificationsSubscription();
    } else {
      this.notificationService.initNotificationsSubscription();
    }

    this.notificationRepo.setWasDialogOpened(true);
  }

  fetchNextPage(): void {
    if (
      this.notificationRepo.getStoreProp('loading') ||
      this.notificationRepo.getStoreProp('error')
    )
      return;

    this.notificationRepo.setPage(
      this.notificationRepo.getStoreProp('currentPage') + 1,
    );
  }
}
